module.exports = __webpack_public_path__ + "img/model3.16bbf2f9.jpg";